import script from "./VendorList.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorList.vue?vue&type=script&setup=true&lang=js"

import "./VendorList.vue?vue&type=style&index=0&id=7337f359&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7337f359"]])

export default __exports__